import React from 'react';
import {Chip, Tooltip, Box, ChipProps} from '@mui/material';

interface SelectDropdownRenderTagsProps {
  value: (string | number)[];
  getTagProps: (params: {index: number}) => ChipProps;
}

export const SelectDropdownRenderTags: React.FC<SelectDropdownRenderTagsProps> = ({
  value,
  getTagProps,
}) => {
  if (value.length === 0) return null;

  if (value.length === 1) {
    return (
      <Chip
        label={value[0]}
        size='small'
        {...getTagProps({index: 0})}
        sx={{
          height: '3vh',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      />
    );
  }

  return (
    <Tooltip
      title={
        <Box sx={{maxHeight: 300, overflow: 'auto'}}>
          {value.join(', ')}
        </Box>
      }
      arrow>
      <Box sx={{display: 'flex', gap: 0.5, alignItems: 'center', maxWidth: '100%'}}>
        <Chip
          label={value[0]}
          size='small'
          {...getTagProps({index: 0})}
          sx={{
            height: '3vh',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        />
        <Chip
          label={`+${value.length - 1}`}
          size='small'
          sx={(theme) => ({
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            cursor: 'pointer',
            height: '3vh',
          })}
        />
      </Box>
    </Tooltip>
  );
};

export default React.memo(SelectDropdownRenderTags);
